import { render, staticRenderFns } from "./tag_input.vue?vue&type=template&id=4263f094&scoped=true"
import script from "./tag_input.vue?vue&type=script&lang=ts"
export * from "./tag_input.vue?vue&type=script&lang=ts"
import style0 from "./tag_input.vue?vue&type=style&index=0&id=4263f094&prod&lang=scss"
import style1 from "./tag_input.vue?vue&type=style&index=1&id=4263f094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4263f094",
  null
  
)

export default component.exports